'use client';
import { notFound } from 'next/navigation';
function unavailable(): never { return notFound(); }
export default unavailable;
export const generateMetadata = unavailable;
export const registerJobportalSchema = unavailable;
export const RegisterFormJobPortal = unavailable;
